import { Value } from '@philips-emr/tws-core';
import { HistoryService, HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationModuleRegistry, isApplicationModule } from '@philips-emr/tws-foundation';

import { Endpoints } from '../definitions/endpoints';
import { Routes } from '../definitions/routes';

export default class Audit {
  addRouteListener(): Function {
    return HistoryService.addListener((path: string) => this.routeChangeLog(path));
  }

  routeChangeLog(path: string): Promise<RequestResponse | void> {
    if (path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    const routes: { [route: string]: string } = {
      [this.parseRoute(Routes.MEUS_DADOS)]: MessageService.translate('beneficiary.meus-dados'),
      [this.parseRoute(Routes.DETALHES_REQUISICAO)]: MessageService.translate('beneficiary.requisicao'),
      [this.parseRoute(Routes.DETALHES_AUTORIZACAO)]: MessageService.translate('beneficiary.autorizacao'),
      [this.parseRoute(Routes.DETALHES_REQUISICAO_AUTORIZACAO)]: MessageService.translate('beneficiary.autorizacao'),
    };

    applicationModuleRegistry.getAll().forEach(module => {
      if (isApplicationModule(module)) {
        routes[this.parseRoute(module.route)] = MessageService.translate(module.name);
      }
    });

    const functionName = routes[this.parseCurrentRoute(path)];

    if (!functionName) {
      return Promise.resolve();
    }

    const body = {
      path,
      current: functionName,
    };

    return Audit.logAuditFunction(body);
  }

  private static logAuditFunction(body: Record<string, Value>): Promise<RequestResponse> {
    return HttpService.post(Endpoints.POST.AUDIT_FUNCTION, { }, { body });
  }

  private parseCurrentRoute(route: string): string {
    const regex = /\d+/g;
    return route.replace(regex, '');
  }

  private parseRoute(route: string): string {
    const regex = /:\w+/g;
    return route.replace(regex, '');
  }
}
